import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import useAuthenticate from '../../hooks/useAuthenticate';

function SchoolInterfaceCtrl(props){

    let navigate = useNavigate()
    const user = useAuthenticate()

    useEffect(() => {

    }, [ user ])

    if(Object.keys(user).length > 0 && user.role === 'interpreter') {

        return(
            <>
                <section className="School_interface">
                    <Outlet/>
                </section>
            </>
        )
    }else {
        return navigate('/')
    }
}

export default SchoolInterfaceCtrl;